import { Expose } from "class-transformer";
import { IsNumber, IsString } from "class-validator";

export class AgentCode {
  @Expose()
  @IsNumber()
  id!: number;
  @Expose()
  @IsString()
  agentId!: string;
  @Expose()
  @IsString()
  system!: string;
}
